// extracted by mini-css-extract-plugin
export default {"container":"Holidays_container__d-kf4","header":"Holidays_header__L9EAb","content":"Holidays_content__MVxDZ","imgMobil":"Holidays_imgMobil__IxSLQ"};